import { FC } from 'react';
import { initServerTranslation } from '@bts-web/utils-lokalise';
import { TFunction } from 'i18next';
import { getCryptoTransfersTransactions } from '../../common/gqlActions/getCryptoTransfersTransactions';
import { CryptoTransferDetails } from '../CryptoTransferDetails/CryptoTransferDetails';
import { getTransactionDetailsTranslations } from '../../transaction-details/utils';
import { CryptoTransfersTransactionsItemType } from '../../transaction-details/types';
import { GenericErrorMessage } from '../../layouts/GenericErrorMessage/GenericErrorMessage';

type CryptoTransferDetailsContentProps = {
  cryptoTransferId: string;
  currency?: string;
  locale: string;
};

export const CryptoTransferDetailsContent: FC<
  CryptoTransferDetailsContentProps
> = async ({ cryptoTransferId, locale }) => {
  const { t } = await initServerTranslation();

  const cryptoTransferData = await getCryptoTransfersTransactions({
    id: cryptoTransferId,
  });

  const translations = getTransactionDetailsTranslations(t as TFunction);

  if (cryptoTransferData.errors?.length) {
    return <GenericErrorMessage />;
  }

  const cryptoTransfersTransactionNode =
    cryptoTransferData?.data?.cryptoTransfersTransactions?.edges?.[0]?.node;

  return (
    <CryptoTransferDetails
      cryptoTransferTransaction={
        cryptoTransfersTransactionNode as NonNullable<CryptoTransfersTransactionsItemType>
      }
      locale={locale}
      translations={translations}
    />
  );
};
